import { render, staticRenderFns } from "./sopa_letras2.vue?vue&type=template&id=88ad69d4&scoped=true"
import script from "./sopa_letras2.vue?vue&type=script&lang=js"
export * from "./sopa_letras2.vue?vue&type=script&lang=js"
import style0 from "./sopa_letras2.vue?vue&type=style&index=0&id=88ad69d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ad69d4",
  null
  
)

export default component.exports